import React, { useContext, useState } from 'react';
import { useLocation } from 'react-router';

import { isInIframe } from '../../utilities';
import { RealProvider, useRealContext } from './RealProvider';
import { OverrideProvider, OverrideContext } from './OverrideProvider';
import type { OverrideProviderContextValue } from './OverrideProvider';

type AuthProviderProps = {
  children: React.ReactNode;
};

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const location = useLocation();

  const [isEmbedded] = useState(
    () => new URLSearchParams(location.search).has('isEmbedded') || isInIframe()
  );

  return isEmbedded ? (
    <OverrideProvider children={children} />
  ) : (
    <RealProvider children={children} />
  );
};

export default React.memo(AuthProvider) as typeof AuthProvider;

export const useAuth0 = (): OverrideProviderContextValue => {
  const overrideContext = useContext(OverrideContext);
  const realContext = useRealContext();

  return overrideContext
    ? { ...overrideContext, isEmbedded: true }
    : realContext;
};
